import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { IconButton, useTheme, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "100vw", sm: "50vw", md: "35vw" },
  bgcolor: "background.paper",
  boxShadow: 0,
  borderRadius: 2,
};

const RemoveModal = ({ isOpen, onClose, onConfirm, email, removeState, loading = false, userToRemove }) => {
  const theme = useTheme();
  const navbarBackground = theme.palette?.navbar?.main;

  const isDistributionList = userToRemove?.sharedWithTypeId === 2 || userToRemove?.isDistributionList;
  const isRemoveAll = removeState === "all";

  const getTitle = () => {
    if (isRemoveAll) return "Remove All Users";
    if (isDistributionList) return "Remove Distribution List";
    return "Remove Email";
  };

  const getMessage = () => {
    if (isRemoveAll) {
      return "Are you sure you want to remove all the users from this collection?";
    }
    if (isDistributionList) {
      return `Are you sure you want to remove the distribution list "${userToRemove.distributionListName}" from this collection?`;
    }
    return `Are you sure you want to remove ${removeState} from this collection?`;
  };

  return (
    <Modal open={isOpen} onClose={loading ? undefined : onClose}>
      <Box sx={modalStyle}>
        <Box sx={{ p: 4 }}>
          <Typography
            variant="h4"
            component="div"
            color="#406da4"
            fontWeight="600"
          >
            {getTitle()}
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            disabled={loading}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="body1" mt={2}>
            {getMessage()}
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: "secondary.main",
            display: "flex",
            justifyContent: "space-between",
            gap: 5,
            px: 5,
            py: 3,
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button 
            onClick={onClose} 
            variant="outlined" 
            sx={{ width: "45%" }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            sx={{
              width: "45%",
            }}
            startIcon={loading && <CircularProgress size={20} />}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RemoveModal;
